module.exports = __webpack_public_path__ + "prod/1.42.2/img/connect-one.8514b5de.png";